module.exports = __webpack_public_path__ + "static/img/jchb1-9.b33a6a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-9.png
// module id = 770
// module chunks = 0